<script>
import { TOKEN_SESSION, USER , TOAST_MESSAGE} from "../../stores";
import { Datatable, PaginationRowCount, PaginationButtons } from "svelte-simple-datatables";
import { onMount } from "svelte";
import * as Fx from '../../globals/Fx.js'
import { createEventDispatcher } from "svelte";
import GLOBALS from "../../globals/GLOBALS";
import ButtonCircular from "../ButtonCircular.svelte";
import html2pdf from '../../html2pdf/dist/html2pdf.bundle.js'


String.prototype.lines = function() { return this.split(/\r*\n/); }
String.prototype.lineCount = function() { return this.lines().length; }

const dispatch = createEventDispatcher();

export let periodo

let DATOSTABLA
let GENERARPDF
let SELECTED = new Object()
let showButtonPdf = false
var sw = false
let reportPDF
let link
let selectedCount = 0
let selectAll = false
let filenamePDF = null
let pdfReady = true
let generatingPdf = false
let rows

$: {
    sw = false    
    Object.keys(SELECTED).forEach((key) => {
        if (SELECTED[key])
            sw = true
    })
    showButtonPdf = sw ? true : false
}

$: {
        selectedCount = 0
        Object.keys(SELECTED).forEach((key) => {
            selectedCount += SELECTED[key] ? 1 : 0
        })
    }

onMount(() =>{
    _FETCH("QUERY","INFOLIQUIDAPDF", {periodo})
})

const _FETCH = async (ROUTE,OPCION, data) => {
    // const data = {};
    const URL = GLOBALS.URL;
    const bearer = "Bearer " + $TOKEN_SESSION;
    await fetch(`${URL}/API/liquidaciones/${ROUTE}/${OPCION}`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            Authorization: bearer,
            "Content-type": "application/json;charset=UTF-8",
        },
    })
        // Handle success
        .then((response) => response.json()) // convert to json
        .then((json) => {
            if (json.result === "success") {
                switch(OPCION){
                    case "INFOLIQUIDAPDF":
                        if (json.result === "success") {
                            DATOSTABLA = json.rows
                        }else{
                        }
                        TOAST_MESSAGE.set(json)
                    break;
                    case "GENERAPDF":
                        if (json.result === "success") {
                            filenamePDF = json.filename
                        }else{
                        }
                        pdfReady = true
                        TOAST_MESSAGE.set(json)
                    break;
                }
            }else{
                TOAST_MESSAGE.set(json)
                if (json.status === 403) TOKEN_SESSION.set(null)
            }

        }) //print data to console
        .catch((err) => -console.log("Request Failed", err)); // Catch errors
};

const _close = () => {
    dispatch("close")
}

const settings = {
        sortable: true,
        rowsPerPage:1000,
        columnFilter: true,
        labels: {
            search: "Buscar...", // search input placeholer
            filter: "Filtro", // filter inputs placeholder
            noRows: "Registro no encontrado",
            info: "Mostrando {start} a {end} de {rows} registros",
            previous: "Anterior",
            next: "Sguiente",
        },
        blocks: {
            searchInput: false,
            paginationButtons: false,
            paginationRowCount: false,
        }
    };

    const _mostrarPDF = () => {
        DATOSTABLA = false
        GENERARPDF = true
        _GenerarPDF()
    }

    const _multiSelectRow = (row) => {
        SELECTED[row.liq_id_contrato] = SELECTED[row.liq_id_contrato] === undefined || !SELECTED[row.liq_id_contrato] ? row : null
    }

    const _GenerarPDF = () => {
        var HTML =  GLOBALS.html.replace(/{valortotal}/g,"$4.789.302") 
        +  GLOBALS.html.replace(/{valortotal}/g,"$2.152.302") +GLOBALS.html.replace(/{valortotal}/g,"$4.789.302") 
        +  GLOBALS.html.replace(/{valortotal}/g,"$2.152.302") +GLOBALS.html.replace(/{valortotal}/g,"$4.789.302") 
        +  GLOBALS.html.replace(/{valortotal}/g,"$2.152.302") +GLOBALS.html.replace(/{valortotal}/g,"$4.789.302") 
        +  GLOBALS.html.replace(/{valortotal}/g,"$2.152.302") +GLOBALS.html.replace(/{valortotal}/g,"$4.789.302") 
        +  GLOBALS.html.replace(/{valortotal}/g,"$2.152.302") +GLOBALS.html.replace(/{valortotal}/g,"$4.789.302") 
        +  GLOBALS.html.replace(/{valortotal}/g,"$2.152.302") +GLOBALS.html.replace(/{valortotal}/g,"$4.789.302") 
        +  GLOBALS.html.replace(/{valortotal}/g,"$2.152.302") +GLOBALS.html.replace(/{valortotal}/g,"$4.789.302") 
        reportPDF.innerHTML = HTML
        
    }

    const _crearPDF = () => {
        generatingPdf = true
        pdfReady = false
        filenamePDF = null
        let pages = []  
        // Object.keys(SELECTED).forEach((row,value) => {
        //     console.log("row",SELECTED[row].sus_nombre, value)
        //     const fechaL = SELECTED[row].liq_fecha_liquidacion.split("-")
        //     const fechaV = SELECTED[row].liq_fecha_vence.split("-")
        //     // const estePeriodo = `${GLOBALS.MES[parseInt(SELECTED[row].liq_periodo.substr(5,2))]}`
        //     const estePeriodo = `${GLOBALS.MES[(SELECTED[row].liq_periodo).toString().substr(5,2)]} de ${(SELECTED[row].liq_periodo).toString().substr(0,4)}`
        //     pages.push(GLOBALS.html
        //         .replace(/{liq_id_contrato}/g,SELECTED[row].liq_id_contrato)
        //         .replace(/{liq_fecha_liquidacion}/g,estePeriodo)
        //         .replace(/{liq_numero}/g,SELECTED[row].liq_numero)
        //         .replace(/{sus_nombre}/g,SELECTED[row].sus_nombre)
        //         .replace(/{sus_nit}/g,SELECTED[row].sus_nit)
        //         .replace(/{sus_id_tarifa}/g,SELECTED[row].sus_id_tarifa)
        //         .replace(/{sus_direccion}/g,SELECTED[row].sus_direccion)
        //         .replace(/{liq_base_gravable}/g,SELECTED[row].liq_base_gravable)
        //         .replace(/{liq_base_liquidacion}/g,Fx.formatter.format(SELECTED[row].liq_csmo_energia))
        //         .replace(/{liq_csmo_energia}/g,Fx.formatter.format(SELECTED[row].liq_csmo_energia))
        //         .replace(/{liq_importe_liquidado}/g,Fx.formatter.format(SELECTED[row].liq_importe_liquidado))
        //         .replace(/{liq_valor_pagado}/g,SELECTED[row].liq_valor_pagado)
        //         .replace(/{dia}/g,fechaL[2])
        //         .replace(/{mes}/g,fechaL[1])
        //         .replace(/{ano}/g,fechaL[0])
        //         .replace(/{diavenc}/g,fechaV[2])
        //         .replace(/{mesvenc}/g,fechaV[1])
        //         .replace(/{anovenc}/g,fechaV[0])
        //     )
        // })
         
        // var worker = html2pdf().from(pages[0]).set({
        //     margin: 1,
        //     filename: `Liquidaciones_${periodo}_${Fx.getTimeDate()}`,
        //     html2canvas: {scale : 2},
        //     // image: { type: 'jpeg', quality: 0.5 },
        //     jsPDF: {orientation: 'portrait', unit: 'mm', format: 'letter', compressPDF: true},
        //     // pagebreak: { before: '.beforeClass' }
        // }).toPdf();
        // for (let index = 1; index < pages.length; index++){
        //     let page = pages[index];
        //     worker = worker.get('pdf').then(function (pdf) {
        //         pdf.addPage();
        //     }).from(page).toContainer().toCanvas().toPdf();
        // }
        //worker = worker.save();

        //test send to server WKHTMLTOPDF
        var data = []
        Object.keys(SELECTED).forEach((row) => {
            if (SELECTED[row]) data.push(row)
        })
        _FETCH("PDF","GENERAPDF", {data, periodo, usu_id : $USER.usu_id})
    }

    const _exportExcel = () => {
        let HTML = `<tabla>
            <thead>
                <th data-key="num">#</th>
                <th data-key="liq_id_contrato">Contrato Id</th>
                <th data-key="liq_periodo">Periodo</th>
                <th data-key="liq_numero">No Liquidación</th>
                <th data-key="sus_nombre">Nombre</th>
                <th data-key="sus_nit">NIT/Cc</th>
                <th data-key="sus_id_tarifa">Tarifa</th>
                <th data-key="sus_direccion">Dirección</th>
                <th data-key="liq_base_gravable">Base gravable</th>
                <th data-key="liq_csmo_energia">Consumo</th>
                <th data-key="liq_importe_liquidado">Importe Liquidado</th>
                <th data-key="liq_valor_pagado">Valor Pagado</th>
                <th data-key="liq_fecha_liquidacion">Fecha Liquidación</th>
                <th data-key="liq_fecha_vence">Fecha Vencimiento</th>
            </thead>
            `
        DATOSTABLA.forEach(element => {
            HTML += `<tr>`
            Object.keys(element).forEach((key) => {
                // HTML += `<td>${element[key]}</td>`
                if ((`liq_csmo_energia|liq_base_gravable|liq_importe_liquidado|liq_valor_pagado`).indexOf(key) > -1){
                    if ((`liq_base_gravable`).indexOf(key) > -1){
                        HTML += `<td>${element[key].toString().cop()}</td>`
                    }else{
                        HTML += `<td>${Fx.formatter.format(element[key]).cop()}</td>`
                    }
                }else{
                    HTML += `<td>${element[key]}</td>`
                }
            })
            HTML += `</td>`
        })
        HTML += `</table>`

        const data = Fx.fnExcelReport(HTML, "Listado Liquidados")
        link.setAttribute("href", data.data_type + ', ' + encodeURIComponent(Fx.myUTF8(data.tab_text)));
        link.setAttribute("download", "Liquidados.xls")
        
    }

    const _toggleSelectAll = () => {
        DATOSTABLA.forEach((row) => {
            SELECTED[row.liq_id_contrato] = selectAll ? row : null
        })   
        selectAll = selectAll ? false : true
    }

</script>

<div class="datatable-container">
    <div class="d-flex direction-row justify-content-between">
        <h4>Generar PDF's</h4>
        <!-- <div class="btn btn-danger align-self-end"  on:click={() => _close()}>Cerrar</div> -->
        <div class="d-flex direction-row justify-content-between">
            <div class="circular d-flex justify-content-center align-items-center" style="background-color:#2980b9" on:click={() => _toggleSelectAll()} title={"Seleccionar/Deseleccionar Todo" }>
                {#if selectedCount === 0}
                     <!-- content here -->
                     <ion-icon name="checkmark-done-outline"></ion-icon>
                {:else}
                     <span style="font-size: 0.8em;">{selectedCount}</span>
                {/if}
            </div> 
            <a class="circular d-flex justify-content-center align-items-center" style="background-color:green"  id="link" bind:this={link} on:click={() => _exportExcel()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-excel-fill" viewBox="0 0 16 16">
                    <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5.884 6.68 8 9.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 10l2.233 2.68a.5.5 0 0 1-.768.64L8 10.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 10 5.116 7.32a.5.5 0 1 1 .768-.64z"/>
                  </svg>
            </a>
            {#if !generatingPdf}
                 {#if selectedCount > 0}
                      <!-- content here -->
                      <div class="circular d-flex justify-content-center align-items-center" style="font-size: 0.5em;display:{showButtonPdf ? "block" : "none"}" on:click={() => {_crearPDF()}}>
                          PDF
                      </div>
                 {/if}
            {:else}
                {#if pdfReady}
                    
                        <div class="circular d-flex justify-content-center align-items-center" style="background-color:#8e44ad;  font-size: 0.8em;display:{showButtonPdf ? "block" : "none"}">
                            <a href="{`${GLOBALS.URL}/API/download?name=${filenamePDF}`}"  download on:click={() => {filenamePDF=null;generatingPdf=false;pdfReady=false}}>
                            <ion-icon style="color:#fff;" name="arrow-down-outline"></ion-icon>
                        </a>
                        </div>
                {:else}
                    <div class="circular d-flex justify-content-center align-items-center" style="background-color:#ffffff66" >
                        <div class="spinner-border text-warning" role="status"></div>
                    </div>
                {/if}
            {/if}
            <div class="circular d-flex justify-content-center align-items-center" on:click={() => _close()}>
                <ion-icon name="close-outline"></ion-icon>
            </div>
        </div>
    </div>
    {#if DATOSTABLA}
            <!-- content here -->
            <!-- {JSON.stringify(DATOSTABLA)} -->
            <Datatable {settings} data={DATOSTABLA} bind:dataRows={rows} id={"tabla-PDF"}>
            <thead>
                <tr>
                    <th data-key="num">#</th>
                    <th data-key="liq_id_contrato">Contrato Id</th>
                    <th data-key="liq_periodo">Periodo</th>
                    <th data-key="liq_numero">No Liquidación</th>
                    <th data-key="sus_nombre">Nombre</th>
                    <th data-key="sus_nit">NIT/Cc</th>
                    <th data-key="sus_id_tarifa">Tarifa</th>
                    <th data-key="sus_direccion">Dirección</th>
                    <th data-key="liq_base_gravable">Base gravable</th>
                    <th data-key="liq_csmo_energia">Consumo</th>
                    <th data-key="liq_importe_liquidado">Importe Liquidado</th>
                    <th data-key="liq_valor_pagado">Valor Pagado</th>
                    <th data-key="liq_fecha_liquidacion">Fecha Liquidación</th>
                    <th data-key="liq_fecha_vence">Fecha Vencimiento</th>
                </tr>
            </thead>
            <tbody>
                {#if rows}
                    {#each $rows as row, idx}
                        <tr
                                class="{idx % 2 === 0 ? 'bg-par' : 'bg-impar'}  
                                        {SELECTED[row.liq_id_contrato] ? 'active' : ''}"
                                on:click={() => _multiSelectRow(row)}
                                
                        >
                            <td class="text-center" >{row.num}</td>
                            <td class="text-center" >{row.liq_id_contrato}</td>
                            <td class="text-center" >{row.liq_periodo}</td>
                            <td class="text-center" >{row.liq_numero}</td>
                            <td class="text-start" >{row.sus_nombre}</td>
                            <td class="text-center" >{row.sus_nit}</td>
                            <td class="text-center" >{row.sus_id_tarifa}</td>
                            <td class="text-start" >{row.sus_direccion}</td>
                            <td class="text-center" >{row.liq_base_gravable}</td>
                            <td class="text-end" >{Fx.formatter.format(row.liq_csmo_energia).cop()}</td>
                            <td class="text-end" >{Fx.formatter.format(row.liq_importe_liquidado).cop()}</td>
                            <td class="text-end" >{Fx.formatter.format(row.liq_valor_pagado).cop()}</td>
                            <td class="text-center" >{row.liq_fecha_liquidacion}</td>
                            <td class="text-center" >{row.liq_fecha_vence}</td>
                        </tr>
                    {/each}
                {/if}
            </tbody>
        </Datatable>
    {:else if GENERARPDF}
        <div class="container">
            <!-- <div class="sheet" bind:this={reportPDF}>

            </div> -->
            <div class="center">
                <div class="spinner-border text-warning" role="status">
                    <span class="visually-hidden">Cargando...</span>
                </div>
                <div class="p-1">Procesando</div>
            </div>
        </div>
    {/if}
</div>
<footer class="d-flex flex-row justify-content-start">
    <div class="d-flex flex-row">
        <PaginationButtons id={"tabla-PDF"}/>
        <PaginationRowCount id={"tabla-PDF"}/>
    </div>
    <!-- <div class="d-flex flex-row px-3">
        <div class="btn btn-danger" style="display:{showButtonPdf ? "block" : "none"}" on:click={() => {_mostrarPDF()}}>PDF's</div>
        <div class="btn btn-warning" style="display:{showButtonPdf ? "block" : "none"}" on:click={() => {_crearPDF()}}>PDF's</div>
    </div> -->
</footer>


<style>

    footer {
        position: fixed;
        display: flex;
        background-color: #fff;
        bottom:0;
        width: 100%;
        padding: 10px;
    }

    th {
        min-width: 10em;
        text-align: left;
    }

    td {
        text-align: left;
        white-space: nowrap;
        padding: 10px 10px;
    }

    tr {
        cursor: pointer;
        color: #3f51b5b5;
        font-size: 0.8em;
        transition: background-color 500ms;
    }

    tr:hover {
        background-color:#14518d33;
        color: #2c3e50;
    }

    tr.active {
        background-color: #2c3e50 !important;
        color: #fff !important;
    }

    .datatable-container {
        height: 76vh;
        max-height: 100vh;
        padding-top: 12px;
        margin-bottom: 40px;
        /* margin: 20px 0; */
    }

    .bg-par {
        background-color: #fafcff;
    }

    .bg-impar {
        background-color: #f2f6ff;
    }

    .circular {
        height: 30px;
        width: 30px;
        border-radius: 50%;
        background-color: #2c3e50;
        color : #fff;
        cursor: pointer;
        transition: all 250ms;
        margin-right: 10px;
    }

    .circular:hover {
        transform: scale(1.2);
    }

    .container {
        /* background-color: rgb(44, 62, 80); */
        height: 70vh;
        padding: 20px;
        overflow-y: auto;
        display: flex;
        justify-content: center;
    }
</style>
